import * as React from "react";
import DivisionComponent from "../../components/500/DivisionComponent";
import { ReportContextProvider } from "../../context/500/ReportContext";
import { CourseAssignmentContextProvider } from "../../context/500/CourseAssignmentContext";

import ReportHeader from "../../components/500/ReportHeader";

function CourseAssignment() {
  return (
    <React.Fragment>
    `<CourseAssignmentContextProvider>
      <ReportContextProvider>

  
          <ReportHeader />


          <DivisionComponent/>
        </ReportContextProvider>
      </CourseAssignmentContextProvider>
      </React.Fragment>
  );
}
export default CourseAssignment;
